import { Typography } from "@mui/material";

export default function Scorecard() {
  return <Typography>Admin Scorecard Page</Typography>;
}
